import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Slider from '../slider';

const DEFAULT_FORMAT_DATE = "YYYY-MM-DD";
const DEFAULT_FORMAT_MONTH = "YYYY-MM";
const DEFAULT_VIEWTYPE = "day";
const DEFAULT_OPTS = {
  min: 0,
  step: 1,
};
const returnDiff = (start, end, viewType) => {
  return moment(end).diff(
    moment(start),
    viewType === "day" ? "days" : "months"
  );
};
const returnAdd = (start, addNum, viewType) => {
  return moment(start).add(addNum, viewType === "day" ? "days" : "months");
};
const compareDate = (start, end) => {
  return moment(end).isAfter(moment(start));
};
const formatValue = (value, format) => {
  return moment(value).format(format);
};

const calculateDiff = props => {
  const { min, max, defaultValue, viewType, format } = props;
  const defaultState = {
    format: format || (viewType === "day"
      ? DEFAULT_FORMAT_DATE
      : DEFAULT_FORMAT_MONTH),
    diff: returnDiff(min, max, viewType),
    defaultValue:
      defaultValue && compareDate ? returnDiff(min, defaultValue, viewType) : 0,
  };
  return defaultState;
};

type SDProps = {
  min: number;
  max: number;
  defaultValue: number;
  viewType: string;
  onChange: ((value: string) => void);
  onAfterChange: ((value: string) => void);
}

type SDState = {
  diff: any;
  defaultValue: number;
  format: string;
}

export default class SliderDate extends Component<SDProps, SDState> {
  static propTypes = {
    viewType: PropTypes.string,
    // format: PropTypes.string,
    onChange: PropTypes.func,
    onAfterChange: PropTypes.func,
  };

  static defaultProps = {
    viewType: DEFAULT_VIEWTYPE,
    onChange: () => {},
    onAfterChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      ...calculateDiff(props),
    };
  }

  handleProps = () => {
    const { diff, defaultValue, format } = this.state;
    const { min, max, defaultValue: propDefault = min } = this.props;
    const marks = {
      0: formatValue(min, format),
      [defaultValue]: formatValue(propDefault, format),
      [diff]: formatValue(max, format),
    };
    const sliderProps = {
      ...DEFAULT_OPTS,
      max: diff,
      defaultValue,
      marks,
    };
    return sliderProps;
  };

  handleAfterChange = value => {
    const { onAfterChange } = this.props;
    onAfterChange(this.formatter(value));
  }

  handleChange = value => {
    const { onChange } = this.props;
    onChange(this.formatter(value));
  }

  formatter = value => {
    const { min, viewType } = this.props;
    const { format } = this.state;
    const nVal = returnAdd(min, value, viewType);
    return formatValue(nVal, format);
  };

  render() {
    return (
      <Slider
        {...this.props}
        {...this.handleProps()}
        tipFormatter={this.formatter}
        onAfterChange={this.handleAfterChange}
        onChange={this.handleChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slider-date/index.tsx